
import BadConscienceDialog from "@/components/thg/BadConscienceDialog.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component } from "vue-property-decorator";
import { ImpactTypeEnum } from "./enum/impact-type.enum";
import ThgImpactSelector from "./ThgImpactSelector.vue";

@Component({
  components: {
    LayoutReportStep,
    BadConscienceDialog
  }
})
export default class ThgImpactSelectorTrees extends ThgImpactSelector implements IReportStep {
  screen = ReportScreenEnum.thgimpactselectortrees;
  mounted() {
    this.setCurrentStep();
    ThgCreateModule.setActiveImpactTypeItems([ImpactTypeEnum.trees, ImpactTypeEnum.payout]);
    ThgCreateModule.setImpactType(ImpactTypeEnum.trees);
    ThgCreateModule.setImpactFactor(30);
    if (this.$route.query.campaign) {
      ThgCreateModule.setCampaign((this.$route.query.campaign as string) || "");
    }
  }

  public header: IReportHeaderData = {
    title: "report.thgImpactSelector.title",
    description: "report.thgImpactSelector.description"
  };

  public instruction: IReportInstructionData = {
    title: "report.thgImpactSelector.instructionTitle",
    text: "report.thgImpactSelectorTrees.instructionText",
    pictures: [AssetEnum.charging],
    example: AssetEnum.charging,
    display: true
  };
}
